<style></style>
<template>
  <div>
    <form @submit="buscarProductoBarra" v-if="facturae && facturae.estado == 'A'">
      <div class="col-sm-12">
        <div class="form-group">
          <label v-bind:class="{
            'text-danger':
              current.errors.codigobarra &&
              current.errors.codigobarra.length > 0,
          }"><b>Agregar Producto</b></label>
          <input v-model="current.codigobarra" class="form-control text-center" ref="codigobarra"
            placeholder="Código de Barra" autofocus v-bind:class="{
              'is-invalid':
                current.errors.codigobarra &&
                current.errors.codigobarra.length > 0,
            }" type="text" />
          <small v-if="current.errors && current.errors.codigobarra" class="form-text text-danger">{{
            current.errors.codigobarra[0] }}</small>
        </div>
        <div class="form-group">
          <button type="submit" class="btn btn-block btn-success">
            Buscar
          </button>
        </div>
      </div>
    </form>
    <div ref="modalAgregarProducto" class="modal fade" id="modalAgregarProducto" role="dialog" tabindex="-1"
      aria-hidden="true" style="display: none">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Ingreso de Producto</h5>
            <button aria-label="Close" class="close" data-dismiss="modal" type="button">
              <span aria-hidden="true">×</span>
            </button>
          </div>
          <form @submit="agregarProducto">
            <div class="modal-body">
              <div v-if="agregar_producto.producto">
                <h4 class="onboarding-title text-success">
                  {{ agregar_producto.producto.sku }}
                </h4>
                <div class="onboarding-text text-success">
                  {{ agregar_producto.producto.nombre }}
                </div>
              </div>
              <br />
              <div class="form-group row">
                <div class="col-6">
                  <label v-bind:class="{
                    'text-danger':
                      agregar_producto.errors &&
                      agregar_producto.errors.cantidad,
                  }">Cantidad:</label>
                  <input v-model="agregar_producto.cantidad" class="form-control text-center" style="font-size: 200%"
                    placeholder="Cant." v-bind:class="{
                      'is-invalid':
                        agregar_producto.errors &&
                        agregar_producto.errors.cantidad,
                    }" type="text" step="1" />
                  <small v-if="agregar_producto.errors &&
                    agregar_producto.errors.cantidad
                    " class="form-text text-danger">{{ agregar_producto.errors.cantidad[0] }}</small>
                </div>
                <div class="col-6">
                  <label v-bind:class="{
                    'text-danger':
                      agregar_producto.errors &&
                      agregar_producto.errors.precio_real,
                  }">Precio:</label>
                  <input v-model="agregar_producto.precio_real" class="form-control text-center" style="font-size: 200%"
                    placeholder="Q" />
                  <small class="text-danger" v-if="agregar_producto.errors &&
                    agregar_producto.errors.precio_real
                    ">{{ agregar_producto.errors.precio_real[0] }}</small>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <ul class="nav nav-pills mt-2 mb-3">
                    <li class="nav-item">
                      <a style="font-size: 12px" class="nav-link" :class="{ active: agregar_producto.estado == 'A' }"
                        @click="agregar_producto.estado = 'A'" data-toggle="tab" href="#">NORMAL</a>
                    </li>
                    <li class="nav-item">
                      <a style="font-size: 12px" class="nav-link" :class="{
                        'active btn-info': agregar_producto.estado == 'B',
                      }" @click="agregar_producto.estado = 'B'" data-toggle="tab" href="#">BONI</a>
                    </li>
                    <li class="nav-item">
                      <a style="font-size: 12px" class="nav-link" :class="{
                        'active btn-secondary':
                          agregar_producto.estado == 'P',
                      }" @click="agregar_producto.estado = 'P'" data-toggle="tab" href="#">PROMO</a>
                    </li>
                  </ul>
                </div>
                <div v-if="agregar_producto.producto &&
                  agregar_producto.producto.is_comodin == true
                  " class="col-12">
                  <div class="form-group">
                    <label v-bind:class="{
                      'text-danger':
                        agregar_producto.errors &&
                        agregar_producto.errors.descripcion,
                    }">Descripción de Producto Comodin</label>
                    <textarea v-model="agregar_producto.descripcion" class="form-control" placeholder="Descripción"
                      v-bind:class="{
                        'is-invalid':
                          agregar_producto.errors &&
                          agregar_producto.errors.descripcion,
                      }" type="number" step="1"></textarea>
                    <small v-if="agregar_producto.errors &&
                      agregar_producto.errors.descripcion
                      " class="form-text text-danger">{{ agregar_producto.errors.mal_estado[0] }}</small>
                  </div>
                </div>
                <div v-if="agregar_producto.producto &&
                  agregar_producto.producto.is_comodin == false
                  " class="col-6">
                  <div class="form-group">
                    <label v-bind:class="{
                      'text-danger':
                        agregar_producto.errors &&
                        agregar_producto.errors.mal_estado,
                    }">Mal Estado:</label>
                    <input v-model="agregar_producto.mal_estado" class="form-control text-center" placeholder="mal_estado"
                      v-bind:class="{
                        'is-invalid':
                          agregar_producto.errors &&
                          agregar_producto.errors.mal_estado,
                      }" type="number" step="1" />
                    <small v-if="agregar_producto.errors &&
                      agregar_producto.errors.mal_estado
                      " class="form-text text-danger">{{ agregar_producto.errors.mal_estado[0] }}</small>
                  </div>
                </div>
                <div v-if="agregar_producto.producto &&
                  agregar_producto.producto.is_comodin == false
                  " class="col-6">
                  <div class="form-group">
                    <label v-bind:class="{
                      'text-danger':
                        agregar_producto.errors &&
                        agregar_producto.errors.corta_fecha_vencimiento,
                    }">Corta Fecha Ven:</label>
                    <input v-model="agregar_producto.corta_fecha_vencimiento" class="form-control text-center"
                      placeholder="Corta Fecha Vencimiento" v-bind:class="{
                        'is-invalid':
                          agregar_producto.errors &&
                          agregar_producto.errors.corta_fecha_vencimiento,
                      }" type="number" step="1" />
                    <small v-if="agregar_producto.errors &&
                      agregar_producto.errors.corta_fecha_vencimiento
                      " class="form-text text-danger">{{
    agregar_producto.errors.corta_fecha_vencimiento[0]
  }}</small>
                  </div>
                </div>
                <div v-if="agregar_producto.producto &&
                    agregar_producto.producto.is_comodin == false
                    " class="col-6">
                  <div class="form-group">
                    <label v-bind:class="{
                      'text-danger':
                        agregar_producto.errors &&
                        agregar_producto.errors.faltante_transporte,
                    }">Faltante Trans:</label>
                    <input v-model="agregar_producto.faltante_transporte" class="form-control text-center"
                      placeholder="Faltante en Transporte" v-bind:class="{
                        'is-invalid':
                          agregar_producto.errors &&
                          agregar_producto.errors.faltante_transporte,
                      }" type="number" step="1" />
                    <small v-if="agregar_producto.errors &&
                      agregar_producto.errors.faltante_transporte
                      " class="form-text text-danger">{{
    agregar_producto.errors.faltante_transporte[0]
  }}</small>
                  </div>
                </div>
                <div v-if="agregar_producto.producto &&
                    agregar_producto.producto.is_comodin == false
                    " class="col-6">
                  <div class="form-group">
                    <label v-bind:class="{
                      'text-danger':
                        agregar_producto.errors &&
                        agregar_producto.errors.sobre_stock,
                    }">Sobre Stock:</label>
                    <input v-model="agregar_producto.sobre_stock" class="form-control text-center"
                      placeholder="Sobre Stock" v-bind:class="{
                        'is-invalid':
                          agregar_producto.errors &&
                          agregar_producto.errors.sobre_stock,
                      }" type="number" step="1" />
                    <small v-if="agregar_producto.errors &&
                      agregar_producto.errors.sobre_stock
                      " class="form-text text-danger">{{ agregar_producto.errors.sobre_stock[0] }}</small>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label v-bind:class="{
                  'text-danger':
                    agregar_producto.errors && agregar_producto.errors.tarima,
                }">Tarima:</label>
                <input v-model="agregar_producto.tarima" class="form-control text-center" placeholder="Tarima"
                  v-bind:class="{
                    'is-invalid':
                      agregar_producto.errors && agregar_producto.errors.tarima,
                  }" type="number" step="1" />
                <small v-if="agregar_producto.errors && agregar_producto.errors.tarima
                  " class="form-text text-danger">{{ agregar_producto.errors.tarima[0] }}</small>
              </div>
            </div>
            <div class="modal-footer">
              <button class="btn btn-primary" type="submit">
                Agregar Producto
              </button>
              <button class="btn btn-secondary" data-dismiss="modal" ref="cerrarAgregarProducto" type="button">
                Cerrar
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ProductosService from "@/services/catalogos/ProductosService";
import DynamicService from "@/services/commons/DynamicService";
import Notifications from "@/notifications/notifications";

export default {
  components: {},
  data() {
    return {
      cb: "",
      barra: "",
      NORMAL: "A",
      NO_RECEPCIONADO: "X",
      NO_SOLICITADO: "N",
      SOLICITAR_AUTORIZACION: "S",
      BONIFICACION: "B",
      PROMOCION: "P",

      agregar_producto: {
        producto: null,
        cantidad: null,
        estado: "A",
        mal_estado: 0,
        corta_fecha_vencimiento: 0,
        faltante_transporte: 0,
        sobre_stock: 0,

        errors: {
          producto: null,
          cantidad: null,
          estado: "A",
          mal_estado: 0,
          corta_fecha_vencimiento: 0,
          faltante_transporte: 0,
          sobre_stock: 0,
        },
      },

      current: {
        codigobarra: "",
        producto: null,
        errors: [],
      },
    };
  },
  props: ["facturae"],
  computed: {},
  mounted() {
    if (this.$refs.codigobarra) {
      this.$refs.codigobarra.focus();
    }
  },
  methods: {
    buscarProductoBarra(e) {
      e.preventDefault();
      let self = this;
      self.barra = self.current.codigobarra;
      if (!self.barra) {
        Notifications.alert.error(
          "Producto",
          "el campo de barra no puede estar en blanco"
        );
        return;
      }
      DynamicService.fetch("cat", "producto-barra", {
        barra: self.barra,
      })
        .then((res) => {
          self.cb = res.data.results[0].producto;
          self.buscarProducto(self.cb);
        })
        .catch((err) => {
          Notifications.alert.error("Producto", "barra no existe");
        });
    },
    buscarProducto(cb) {
      let self = this;
      cb = self.current.codigobarra;
      ProductosService.getById(cb)
        .then((res) => {
          self.agregar_producto.producto = res.data;
          $("#modalAgregarProducto").modal("show");
        })
        .catch((err) => {
          Notifications.alert.error("Producto", err.response.data.detail);
        });
    },
    agregarProducto(e) {
      let self = this;
      e.preventDefault();

      let params = Object.assign({}, self.agregar_producto);
      params.producto = params.producto.sku;
      DynamicService.postAction(
        "wms",
        "facturas",
        self.facturae.id,
        "agregar_detalle_factura",
        params
      )
        .then((res) => {
          // self.$emit("refresh", null);
          self.refresh();
          $("#modalAgregarProducto").modal("hide");
          Notifications.alert.success(
            "Agregar detalle",
            "Se ha guardado la Información."
          );
          this.refreshDefault();
          this.agregar_producto.estado = "A";
        })
        .catch((err) => {
          console.log(err.response.data);
          if (err.response.data.detail) {
            Notifications.alert.error("Agregar detalle", err.response.data.detail);
          }

          self.agregar_producto.errors = Object.assign({}, err.response.data);
        });
    },
    refreshDefault() {
      this.current.codigobarra = "";
      delete this.agregarProducto.precio_real;
      this.agregar_producto = {
        producto: "",
        cantidad: 0,
        mal_estado: 0,
        corta_fecha_vencimiento: 0,
        faltante_transporte: 0,
        sobre_stock: 0,
        errors: "",
      };
    },
    refresh() {
      this.$emit("refrescar", {});
    },
  },
};
</script>
